import classNames from "classnames/bind";
import { CloseIcon } from "common/assets/icons";
import React, { ReactNode } from "react";
import styles from "./Box.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  centeredContent?: boolean;
  rounded?: boolean;
  kind?: "primary" | "secondary" | "information";
  onClose?: () => void;
  children: ReactNode;
  alternativeSectionClassName?: string;
}

export const Box: React.FC<React.PropsWithChildren<Props>> = ({
  centeredContent,
  children,
  rounded = true,
  kind = "secondary",
  onClose,
  alternativeSectionClassName,
}) => {
  const mainStyle = classNameBuilder({
    container: true,
    centered: centeredContent,
    rounded: rounded,
    primary: kind === "primary",
    secondary: kind === "secondary",
    information: kind === "information",
  });

  return (
    <section
      className={
        alternativeSectionClassName ? alternativeSectionClassName : mainStyle
      }
    >
      {onClose && (
        <button onClick={onClose} className={styles.closeButton}>
          <CloseIcon color="black" />
        </button>
      )}
      {children}
    </section>
  );
};
